import { ProductionLine } from '@app:types';

export type WebsocketAction<Actions> = {
  [K in keyof Actions]: {
    type: K;
    payload: Actions[K];
  };
}[keyof Actions];

export type UIActions = {
  'user.moveTaskToFront': { requestId: string };
  'user.deleteTask': { requestId: string };
  'user.moveTaskToProductionLine': {
    targetLocationId: string;
    orderId: string;
    productId: string;
  };
  'user.deviceResponse': {
    deviceId: string;
    requestId: string;
    actionId: string;
  };
  'user.retryTask': { requestId: string };
};

export type ServerResponses = {
  'location.update': { locationId: string; productionLines: ProductionLine[] };
  'location.notify': {
    type: 'success' | 'error' | 'warning' | 'info' | 'loading';
    action: string;
    description?: string;
  };
};

export enum ReadyState {
  UNINSTANTIATED = -1,
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
  MAX_RETRIES_REACHED = 4,
}

export type WebsocketData = {
  productionLines: ProductionLine[];
};

export type WebSocketState = {
  send: (action: WebsocketAction<UIActions>) => void;
  readyState: ReadyState;
  isConnecting: boolean;
};

export type ConnectionState = {
  readyState: ReadyState;
  retries: number;
  lastError?: string;
  lastConnected?: Date;
};

export type ConnectionConfig = {
  uri: string;
  maxRetries: number;
  connectionTimeout: number;
  reconnectDelay: number;
  initialConnectDelay: number;
};

export type UseWebSocketConnectionReturn = {
  transport: WebSocket | null;
  readyState: ReadyState;
  connect: () => void;
  disconnect: () => void;
  reset: () => void;
};
